
























































































































































































































































































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
  watch,
} from '@vue/composition-api';
import { useMutation, useQuery, useResult } from '@vue/apollo-composable';
import { useFormat, useRouter } from 'vivat';
import _ from 'lodash';
import PrettyCheck from 'pretty-checkbox-vue/check';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';
import CommonModalWithDriverSelector from '@/components/DeliveryNote/CommonModalWithDriverSelector.vue';
import CommonModalWithVehicleSelector from '@/components/DeliveryNote/CommonModalWithVehicleSelector.vue';
import CommonModalWithDivideDelivery from '@/components/DeliveryNote/CommonModalWithDivideDelivery.vue';
import CommonModalWithDriverAbsenceEditor from '@/components/Driver/CommonModalWithDriverAbsenceEditor.vue';
import ViewDeliveryMarkerModal from '@/components/Delivery/ViewDeliveryMarkerModal.vue';
import CommonAreaCodeSelector from '@/components/Setting/CommonAreaCodeSelector.vue';
import CommonIconTop from '@/components/CommonIconTop.vue';
import ExpandButton from '@/components/DeliveryNote/ExpandButton.vue';
import DeliveryNoteObject from '@/components/DeliveryNote/DeliveryNoteObject.vue';
import LongVehicleWithDriverObject from '@/components/DeliveryNote/LongVehicleObject.vue';
import LongDeliveryObject from '@/components/DeliveryNote/LongDeliveryObject.vue';

import getDeliveryNotesForArrange from '@/gql/deliveryNote/getDeliveryNotesForArrange.gql';
import createDeliveryNote from '@/gql/deliveryNote/createDeliveryNote.gql';
import updateDeliveryNote from '@/gql/deliveryNote/updateDeliveryNote.gql';
import deleteDeliveryNote from '@/gql/deliveryNote/deleteDeliveryNote.gql';
import getDeliveryNote from '@/gql/deliveryNote/getDeliveryNote.gql';

import useCreateSingleDeliveryNote from '@/views/DeliveryNote/useCreateSingleDeliveryNote';
import useCreateMultiDeliveryNote from '@/views/DeliveryNote/useCreateDeliveryNote';
import useDeliveryAreaCode from '@/useDeliveryAreaCode';
import useDelivery from '@/useDelivery';
import useDriverProfile from '@/useDriverProfile';
import useAuth from '@/useAuth';
import useDeliveryNoteStatus, { BASE_DELIVERY_NOTE } from '@/useDeliveryNote';

const NOW = useFormat.date().computerShortDate();
interface Vehicle {
  id: string;
  driver: { id: string };
}
interface DeliveryNote {
  id: number;
  vehicle?: Vehicle;
  deliveries: any[];
  status: string;
  driver: string;
  deliveryManCount: number;
  uniqueId: string;
  tempDeliveriesId?: number[];
  saved: boolean;
  editable?: boolean;
}

const CreateSingleDeliveryNote = defineComponent({
  components: {
    CommonModalWithPreset,
    CommonModalWithDriverSelector,
    CommonModalWithVehicleSelector,
    CommonModalWithDivideDelivery,
    CommonModalWithDriverAbsenceEditor,
    ViewDeliveryMarkerModal,
    CommonAreaCodeSelector,
    PrettyCheck,
    CommonIconTop,
    ExpandButton,
    DeliveryNoteObject,
    LongVehicleWithDriverObject,
    LongDeliveryObject,
  },
  setup() {
    const { route, router } = useRouter();
    const forceRender = ref(true);
    const YESTERDAY = useFormat.date().dayjs.subtract(1, 'day').format('YYYY-MM-DD');
    const LAST7DAY = useFormat.date().dayjs.subtract(7, 'day').format('YYYY-MM-DD');
    // const filterDateRange = ref('2022-03-29');
    const filterDateRange = ref(NOW);
    const toCurrency = (number: string) => useFormat.number(number).currency();
    const displayDate = (date: string) => useFormat.date(date).displayFullThaiDate();
    const toDecimalFormat = (string: any) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    const { translateDistanceType, farthestDeliveryDistanceIndex } = useDeliveryAreaCode();
    const { sumPackagesPrice } = useDelivery();
    const { deliveriesStatusToDeliveryNoteStatus } = useDeliveryNoteStatus();
    const { mapLastSevenDaysDeliveryNotes } = useDriverProfile();
    const useCreateDeliveryNote = useCreateSingleDeliveryNote();
    const { me } = useAuth();
    const {
      sortDeliveryDisplay,
      sortDeliveryList,
    } = useCreateMultiDeliveryNote(filterDateRange);

    const hubs = computed(() => me.company.hubs || []);

    const deliveryNotes: Ref<DeliveryNote[]> = ref([]);
    const tempDelivery: Ref<any[]> = ref([]);

    const deliveryNote: Ref<any> = ref({ ...BASE_DELIVERY_NOTE });
    function startOver() {
      router.push({
        name: 'DeliveryNoteCreateSingle',
      });
      useCreateDeliveryNote.selectedDeliveries.value = [];
      useCreateDeliveryNote.selectedDeliveriesId.value = [];
      deliveryNote.value = { ...BASE_DELIVERY_NOTE };
    }

    const mapDNIntoFormat = (dn: any) => ({
      id: dn.id,
      ...dn,
      vehicle: {
        ...dn.vehicle,
        driver: {
          id: dn.driver.id,
          name: dn.driver.name,
          avatarUrl: dn.driver.avatarUrl,
          lastSevenDay: mapLastSevenDaysDeliveryNotes(dn.driver.paginatedDeliveryNotes.data),
        },
      },
      deliveries: [
        ...dn.deliveries.map((delivery: any) => ({
          ...delivery,
          // packagesPrice: sumPackagesPrice(delivery.packages),
        })),
        ...dn.loggedDeliveries.map((delivery: any) => ({
          ...delivery,
          // packagesPrice: sumPackagesPrice(delivery.packages),
        })),
      ],
      tempDeliveriesId: dn.deliveries.map((delivery: any) => (delivery.id)),
    });

    // Assigning the deliveries in the delivery note into the selected array.
    function assignDeliveriesInDeliveryNoteIntoSelectedArray() {
      // eslint-disable-next-line
      (deliveryNoteResult.value.deliveries as any)?.forEach((item: any) => {
        useCreateDeliveryNote.selectedDeliveries.value.push(item);
        useCreateDeliveryNote.selectedDeliveriesId.value.push(item.id);
      });
    }

    // Watching the selectedDestinationsId in the filter object. If it changes, it will check if the
    // deliveryNote.value.deliveries.length is greater than 0 and if the destinationHub.id is equal to
    // the selectedDestinationsId. If all of these conditions are met, it will call the
    // assignDeliveriesInDeliveryNoteIntoSelectedArray() function.
    watch(() => useCreateDeliveryNote.filter.selectedDestinationsId, (newVal: any, oldVal: any) => {
      if (newVal !== oldVal && deliveryNote.value.deliveries.length > 0 && deliveryNote.value.deliveries[0].destinationHub.id === useCreateDeliveryNote.filter.selectedDestinationsId) {
        assignDeliveriesInDeliveryNoteIntoSelectedArray();
      }
    });

    const { result: getDeliveryNoteResult, loading: deliveryNoteLoading } = useQuery(getDeliveryNote, computed(() => ({
      id: route.value.params?.id || -1,
    })), () => ({ fetchPolicy: 'cache-and-network', enabled: route.value.name === 'DeliveryNoteEdit' }));
    const deliveryNoteResult = useResult(getDeliveryNoteResult, { ...BASE_DELIVERY_NOTE }, (data: any) => data.deliveryNote);
    watch(() => getDeliveryNoteResult.value, (newVal: any, oldVal: any) => {
      if (!deliveryNoteLoading.value && newVal?.id !== route.value.params.id) {
        deliveryNote.value = mapDNIntoFormat(deliveryNoteResult.value);

        useCreateDeliveryNote.selectedDeliveriesId.value = [];
        useCreateDeliveryNote.selectedDeliveries.value = [];
        assignDeliveriesInDeliveryNoteIntoSelectedArray();
        // useCreateDeliveryNote.deliveries.value = [...deliveryNoteResult.value.deliveries, ...useCreateDeliveryNote.deliveries.value];
      }
    });

    // Get DeliveryNote
    const { result: getDeliveryNotesResult, loading: deliveryNotesLoading } = useQuery(getDeliveryNotesForArrange, computed(() => ({
      filterDeliveryDateBetween: { from: `${filterDateRange.value}`, to: `${filterDateRange.value}` },
      filterDriverDeliveryNotesCreatedAtBetween: { from: `${LAST7DAY} 00:00:00`, to: `${YESTERDAY} 23:59:59` },
      searchDeliveryNoteId: useCreateDeliveryNote.filter.deliveryNoteSearch ? `%${useCreateDeliveryNote.filter.deliveryNoteSearch}%` : undefined,
    })), () => ({ fetchPolicy: 'network-only' }));
    const deliveryNotesResult = useResult(getDeliveryNotesResult, [], (data: any) => data.deliveryNotes.data);
    watch(() => getDeliveryNotesResult.value, () => {
      if (!deliveryNotesLoading.value) {
        if (deliveryNotesResult.value.length === 0) deliveryNotes.value = [];
        else {
          deliveryNotes.value = deliveryNotesResult.value.map(mapDNIntoFormat);
        }
      }
    });

    // Scroll on sidebar Handler
    function scrollDeliveriesAreaHandler(visible: any) {
      if (!(useCreateDeliveryNote.getDeliveriesLoading.value) && useCreateDeliveryNote.deliveriesPaginatorInfo.value.lastPage > useCreateDeliveryNote.deliveriesPage.value && visible) {
        useCreateDeliveryNote.deliveriesPage.value += 1;
      }
    }

    const deliveryNoteInformation = computed(() => {
      let totalArrangeDelivery = 0;
      let weight = 0;
      let price = 0;
      let packagesPrice = 0;
      let volume = 0;
      const distanceArr: string[] = [];
      const deliveryAreaCodeArr: string[] = [];
      const deliveries = useCreateDeliveryNote.selectedDeliveries.value;
      totalArrangeDelivery += deliveries.length;
      deliveries.forEach((delivery: any) => {
        weight += delivery.totalWeight;
        price += delivery.deliveryFee;
        packagesPrice += sumPackagesPrice(delivery.packages);
        distanceArr.push(delivery.area?.distanceType || '');
        deliveryAreaCodeArr.push(`${delivery.area?.code || ''} ${translateDistanceType(delivery.area?.distanceType)}`);
        delivery.packages.forEach((pack: any) => {
          volume += pack.volume || 0;
        });
      });
      const distanceIndex = farthestDeliveryDistanceIndex(distanceArr);
      return {
        totalArrangeDelivery,
        weight,
        price,
        volume,
        distance: distanceArr[distanceIndex as number],
        deliveryAreaCode: deliveryAreaCodeArr[distanceIndex as number],
        packagesPrice,
        area: deliveries[distanceIndex as number]?.area,
        status: deliveriesStatusToDeliveryNoteStatus(deliveries),
      };
    });

    // Use to computed Arrange Panel size
    const showDestinationList = ref(true);
    const showAreaCodeList = ref(true);
    const showDeliveryNoteList = ref(true);
    const mainPanelWidth = computed(() => {
      let width = 8;
      if (showDestinationList.value) width += 18.8;
      if (showAreaCodeList.value) width += 18.8;
      if (showDeliveryNoteList.value) width += 18.8;
      if (showDestinationList && showAreaCodeList.value && showDeliveryNoteList.value) width -= 0.1;
      return `${width}rem`;
    });

    // Use to toggle Vehicle Selector modal
    const driverSelectorModal = ref(null);
    const vehicleSelectorModal = ref(null);
    function pendingSelectDriver() {
      (driverSelectorModal.value as any).open();
    }
    function setDriverOnVehicle(driver: any) {
      deliveryNote.value.driver = driver;
    }
    function pendingSelectVehicle() {
      (vehicleSelectorModal.value as any).open();
    }
    function setVehicleOnDeliveryNote(vehicle: any) {
      deliveryNote.value.vehicle = vehicle;
      if (!(deliveryNote.value.driver) && deliveryNote.value.driver?.id !== -1) {
        deliveryNote.value.driver = { ...vehicle.defaultDriver };
      }
    }

    // Handler DeliveryManCount
    function changeDeliveryManCount($event: number, index: number) { deliveryNotes.value[index].deliveryManCount = $event; }

    // Pending to save DeliveryNote
    const pendingToSaveIndex = ref(-1);
    const refetchQueries = ['getDeliveries', 'getVehicles', 'getDeliveryNotesForArrange', 'getDeliveryNote', 'getMostStableTotalItem', 'countDeliveryGroups'];
    const createDeliveryNoteInput = computed(() => ({
      // status: deliveryNote.status,
      status: deliveryNoteInformation.value?.status || deliveryNote.value.status,
      driver: { connect: parseInt((deliveryNote.value.driver as any)?.id, 10) },
      vehicle: { connect: parseInt((deliveryNote.value.vehicle as any)?.id, 10) },
      deliveries: {
        update: useCreateDeliveryNote.deliveries.value
          .filter((delivery: any) => useCreateDeliveryNote.selectedDeliveriesId.value.indexOf(delivery.id) > -1)
          .map((delivery: { id: string }, index: number) => ({ id: parseInt(delivery.id, 10), order: index + 1 })),
        disconnect: deliveryNote.value.tempDeliveriesId?.filter((id: any) => useCreateDeliveryNote.selectedDeliveriesId.value.indexOf(id) === -1),
      },
      deliveryManCount: deliveryNote.value.deliveryManCount,
      distanceType: deliveryNoteInformation.value.distance || 'NA',
      deliveryDate: useCreateDeliveryNote.filter.deliveryLocationDate || NOW,
      area: deliveryNoteInformation.value?.area?.id ? { connect: deliveryNoteInformation.value.area?.id } : undefined,
    }));
    const createDeliveryNoteMutation = useMutation(createDeliveryNote, () => ({
      variables: {
        input: createDeliveryNoteInput.value,
      },
      refetchQueries,
    }));
    const updateDeliveryNoteMutation = useMutation(updateDeliveryNote, () => ({
      variables: {
        id: route.value.params.id,
        input: createDeliveryNoteInput.value,
      },
      refetchQueries,
    }));
    function pendingToSave() {
      if (route.value.name === 'DeliveryNoteEdit') {
        updateDeliveryNoteMutation.mutate();
      } else createDeliveryNoteMutation.mutate();
    }

    function afterSaveDone(index: number) {
      deliveryNotes.value[index].saved = true;
    }
    const successCreateDeliveryNoteModal = ref(null);
    const errorCreateDeliveryNoteModal = ref(null);
    createDeliveryNoteMutation.onDone((result: any) => {
      deliveryNote.value.id = result.data.createDeliveryNote.id;
      deliveryNote.value.uniqueId = result.data.createDeliveryNote.uniqueId;
      router.push({ name: 'DeliveryNoteEdit', params: { id: result.data.createDeliveryNote.id } });
      (successCreateDeliveryNoteModal.value as any).compose({ action: 'สร้าง', entity: 'รายการ สำเร็จ' });
    });
    updateDeliveryNoteMutation.onDone(() => {
      (successCreateDeliveryNoteModal.value as any).compose({ action: 'บันทึก', entity: 'รายการ สำเร็จ' });
    });
    function mutationErrorHandler(mutationResponse: any) {
      let message = '';
      let entity = 'คนขับ';
      const responseMessage = mutationResponse.message;
      if (responseMessage === 'DRIVER' || responseMessage === 'LOADER') {
        switch (responseMessage) {
          case 'LOADER':
            entity = 'พนักงานยกของ';
            break;
          default:
            entity = 'คนขับ';
        }
        message = `โปรดตรวจเช็คค่าตอบแทน${entity} ให้ตรงกับรายการที่ท่านสร้าง`;
      }
      (errorCreateDeliveryNoteModal.value as any).compose({ body: message });
    }
    createDeliveryNoteMutation.onError((res: any) => {
      mutationErrorHandler(res);
    });
    updateDeliveryNoteMutation.onError((res: any) => {
      mutationErrorHandler(res);
    });
    function saveHandler(deliveryNoteIndex: number, allowToSave: boolean) {
      if (deliveryNotes.value[deliveryNoteIndex].saved) {
        deliveryNotes.value[deliveryNoteIndex].saved = false;
      } else if (allowToSave) {
        pendingToSaveIndex.value = deliveryNoteIndex;
        if (deliveryNotes.value[deliveryNoteIndex].id > -1) updateDeliveryNoteMutation.mutate();
        else createDeliveryNoteMutation.mutate();
      } else {
        (errorCreateDeliveryNoteModal.value as any).compose({ body: 'โปรดเลือกคนขับรถ' });
      }
    }

    // Divide Delivery stuff
    const pendingDivideDelivery: Ref<number> = ref(-1);
    const divideDeliveryModal = ref(null);
    function openDivideDeliveryModal($event: number) {
      pendingDivideDelivery.value = $event;
      (divideDeliveryModal.value as any).open();
    }

    // Use to render map modal
    const viewMapModal = ref(null);
    const mapMarkers: Ref<{ delivery: any; lat: number; lng: number; open: boolean }[]> = ref([]);
    function pendingToViewMap() {
      const positionsLat: any[] = [];
      const positionsLong: any[] = [];
      mapMarkers.value = useCreateDeliveryNote.selectedDeliveries.value.filter((dv: any) => {
        const latIndex = positionsLat.indexOf(dv.computedLatLong.lat);
        const longIndex = positionsLong.indexOf(dv.computedLatLong.long);
        if ((latIndex !== -1 && (positionsLong.length > latIndex && positionsLong[latIndex] === dv.computedLatLong.long))
          || (longIndex !== -1 && (positionsLat.length > longIndex && positionsLat[longIndex] === dv.computedLatLong.lat))
        ) return undefined;
        positionsLat.push(dv.computedLatLong.lat);
        positionsLong.push(dv.computedLatLong.long);
        return dv;
      }).map((dv: any) => ({
        delivery: dv,
        open: false,
        lat: parseFloat(dv.computedLatLong.lat) >= -90 && parseFloat(dv.computedLatLong.lat) <= 90 ? parseFloat(dv.computedLatLong.lat) : 0,
        lng: parseFloat(dv.computedLatLong.long) >= -180 && parseFloat(dv.computedLatLong.long) <= 180 ? parseFloat(dv.computedLatLong.long) : 0,
      }));
      (viewMapModal.value as any).open();
    }

    // ==============================================
    // ===== Use to delete Delivery from system =====
    // ==============================================
    const refetchQueriesList = [
      'getDeliveryNotes', 'countDeliveryNote', 'getDeliveries', 'getDeliveryNotesForArrange', 'getVehicles',
    ];
    const deleteDeliveryNoteModal = ref(null);
    const deleteDeliveryNoteMutation = useMutation(deleteDeliveryNote, {
      refetchQueries: refetchQueriesList,
    });
    function deleteDeliveryNoteAction(deliveryId: number) {
      deleteDeliveryNoteMutation.mutate({
        id: deliveryId,
      });
    }
    function pendingDeleteDeliveryNote(deliveryNoteIndex: number) {
      if (deliveryNotes.value[deliveryNoteIndex].id > -1) {
        (deleteDeliveryNoteModal.value as any).compose({ action: 'ลบ', id: deliveryNotes.value[deliveryNoteIndex].id });
      } else deliveryNotes.value.splice(deliveryNoteIndex, 1);
    }

    const computedExpandButtonStyle = computed(() => {
      const base = 'border-top-right-radius: 1rem; margin-top:';
      let areaListButtonMargin = 0;
      let deliveryNoteButtonMargin = 0;
      if (showDestinationList.value && showAreaCodeList.value && !showDeliveryNoteList.value) deliveryNoteButtonMargin = 26;
      else if (showDestinationList.value && !showAreaCodeList.value) {
        if (showDeliveryNoteList.value) {
          areaListButtonMargin = 26;
        } else if (!showDeliveryNoteList.value) {
          areaListButtonMargin = 26;
          deliveryNoteButtonMargin = 52;
        }
      } else if (!showDestinationList.value && !showAreaCodeList.value) {
        if (showDeliveryNoteList.value) areaListButtonMargin = 26;
        else if (!showDeliveryNoteList.value) {
          areaListButtonMargin = 26;
          deliveryNoteButtonMargin = 52;
        }
      } else if (!showDestinationList.value && showAreaCodeList.value && !showDeliveryNoteList.value) deliveryNoteButtonMargin = 26;

      return {
        areaList: areaListButtonMargin > 0 ? `${base} ${areaListButtonMargin}px;` : '',
        deliveryNoteList: deliveryNoteButtonMargin > 0 ? `${base} ${deliveryNoteButtonMargin}px;` : '',
      };
    });

    const deliveryStats = computed(() => {
      const { total } = useCreateDeliveryNote.mostStableTotalItem.value.deliveries.paginatorInfo;
      const notArrange = total - useCreateDeliveryNote.selectedDeliveriesId.value.length;
      // if (route.value.name === 'DeliveryNoteEdit') {
      //   total = useCreateDeliveryNote.mostStableTotalItem.value.deliveries.paginatorInfo.total;
      //   notArrange = total - useCreateDeliveryNote.selectedDeliveriesId.value.length;
      // }
      return {
        total,
        arranged: useCreateDeliveryNote.selectedDeliveriesId.value.length,
        notArrange,
        resend: useCreateDeliveryNote.countResend.value,
      };
    });

    return {
      toCurrency,
      toDecimalFormat,
      displayDate,
      filterDateRange,
      translateDistanceType,
      startOver,
      forceRender,

      me,
      hubs,
      deliveryStats,

      computedExpandButtonStyle,

      ...useCreateDeliveryNote,

      scrollDeliveriesAreaHandler,

      deliveryNote,
      deliveryNotes,
      createDeliveryNote,
      createDeliveryNoteMutation,
      sortDeliveryDisplay,
      sortDeliveryList,

      tempDelivery,
      createDeliveryNoteInput,

      successCreateDeliveryNoteModal,
      errorCreateDeliveryNoteModal,

      deliveryNoteInformation,

      mainPanelWidth,
      showDestinationList,
      showAreaCodeList,
      showDeliveryNoteList,

      driverSelectorModal,
      pendingSelectDriver,
      setDriverOnVehicle,
      vehicleSelectorModal,
      pendingSelectVehicle,
      setVehicleOnDeliveryNote,

      changeDeliveryManCount,

      saveHandler,
      pendingToSave,

      divideDeliveryModal,
      pendingDivideDelivery,
      openDivideDeliveryModal,

      // use to view map on each DeliveryNote
      viewMapModal,
      mapMarkers,
      pendingToViewMap,

      deleteDeliveryNoteModal,
      deleteDeliveryNoteAction,
      pendingDeleteDeliveryNote,
    };
  },
});

export default CreateSingleDeliveryNote;
